import "./_Button.scss";

export const Button = ({
  text,
  inverted = false,
  className = "primary",
  disabled,
  extraStyle,
  children,
  ...props
}) => (
  <button
    disabled={disabled}
    className={`button button--primary ${className} ${
      inverted ? "button--primary--inverted" : ""
    }
    ${disabled && "button--primary--disabled"}
    ${extraStyle}
    `}
    {...props}
  >
    {text || children}
  </button>
);
